import { router, useGlobalSearchParams } from 'expo-router'
import { useRef } from 'react'

import { useAppStore } from '@/store/useAppStore'

const useOrganizationRouteSync = () => {
  const hasRun = useRef(false)
  const { orgId: orgIdFromRoute } = useGlobalSearchParams<{
    orgId?: string
  }>()

  if (hasRun.current) return
  hasRun.current = true

  const state = useAppStore.getState()
  const currentOrgId = state.currentOrganization.organization?.id

  if (orgIdFromRoute && orgIdFromRoute !== currentOrgId) {
    state.setCurrentOrganization({
      organization: {
        id: orgIdFromRoute,
        adoptionContract: null,
        logo: null,
        qrCode: null,
        name: '',
      },
    })
  } else if (!orgIdFromRoute && currentOrgId) {
    router.replace(`/organization/${currentOrgId}/dashboard`)
  }
}

export default useOrganizationRouteSync
